import React from "react";

import { P } from "core/Typography";
import { OurCustomersContainer, LogoSet } from "./styles";

import { apiCustomerLogos, apiCustomerLogoIconComponents } from "./data";

const logos = apiCustomerLogos.map(logoInfo => {
    const { icon, title } = logoInfo;
    const Icon = apiCustomerLogoIconComponents[icon];

    return <Icon key={title} title={title} />;
});

const OurCustomers = () => (
    <OurCustomersContainer>
        <P size={16}>Our customers:</P>
        <LogoSet>{logos}</LogoSet>
    </OurCustomersContainer>
);

export default OurCustomers;
